
import { Component, Vue } from 'vue-property-decorator';
import HeaderNav from '@/components/header-nav.vue';
import { BytedIconDelete } from '@byte-design/vue-icons';
import { notificationSecondCategory, NotificatinStatus } from '@/const/notification';
import { getNotifyDetail, updateNotifyStatus } from '@/service';

@Component({
  name: 'NotificationDetail',
  components: { HeaderNav, BytedIconDelete },
})
export default class NotificationDetail extends Vue {
  isDeleting = false;
  detail: any = {};
  timer = 0;

  created() {
    const { get_id = '', version = '' } = this.$route.query;
    this.getDetail({ id: get_id as string, version: version as string });
  }

  async getDetail(params: { id: string; version: string }) {
    try {
      const info = await getNotifyDetail(params);
      const detail = info.data.notification_data;
      this.detail = {
        title: detail?.title ?? '',
        date: (detail.create_time || '').split(' ').slice(0, 2).join(' '),
        content: detail.content,
        category: notificationSecondCategory.find(i => i.value === detail.notification_type)?.label,
        id: detail.notification_id,
        version: detail.version,
      };
    } finally {
      console.log('finally');
    }
  }

  onBack() {
    this.$router.back();
  }

  beforeDestroy() {
    clearTimeout(this.timer);
  }

  async onDelete() {
    if (!this.detail.id || this.isDeleting) {
      return;
    }
    try {
      this.isDeleting = true;

      await updateNotifyStatus({
        notification_id_list: [{ notification_id: this.detail.id, version: this.detail.version }],
        notification_status: NotificatinStatus.DELETE,
      });
      this.$toast({
        message: 'delete successfully',
        type: 'success',
      });
      this.timer = window.setTimeout(() => {
        this.onBack();
      }, 300);
    } catch (error) {
      console.log(error);
    } finally {
      this.isDeleting = false;
    }
  }
}
